import { render, staticRenderFns } from "./NavigationDrawer.vue?vue&type=template&id=72dc546a&scoped=true"
import script from "./NavigationDrawer.vue?vue&type=script&lang=ts"
export * from "./NavigationDrawer.vue?vue&type=script&lang=ts"
import style0 from "./NavigationDrawer.vue?vue&type=style&index=0&id=72dc546a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72dc546a",
  null
  
)

export default component.exports